type TextureType = {
    texelSize: number;
};

const textureTypes: Record<GPUTextureFormat, TextureType> = {
    "r8unorm": { texelSize: 1 },
    "r8snorm": { texelSize: 1 },
    "r8uint": { texelSize: 1 },
    "r8sint": { texelSize: 1 },
    "r16uint": { texelSize: 2 },
    "r16sint": { texelSize: 2 },
    "r16float": { texelSize: 2 },
    "rg8unorm": { texelSize: 2 },
    "rg8snorm": { texelSize: 2 },
    "rg8uint": { texelSize: 2 },
    "rg8sint": { texelSize: 2 },
    "r32uint": { texelSize: 4 },
    "r32sint": { texelSize: 4 },
    "r32float": { texelSize: 4 },
    "rg16uint": { texelSize: 4 },
    "rg16sint": { texelSize: 4 },
    "rg16float": { texelSize: 4 },
    "rgba8unorm": { texelSize: 4 },
    "rgba8unorm-srgb": { texelSize: 4 },
    "rgba8snorm": { texelSize: 4 },
    "rgba8uint": { texelSize: 4 },
    "rgba8sint": { texelSize: 4 },
    "bgra8unorm": { texelSize: 4 },
    "bgra8unorm-srgb": { texelSize: 4 },
    "rgb9e5ufloat": { texelSize: 4 },
    "rgb10a2unorm": { texelSize: 4 },
    "rg11b10ufloat": { texelSize: 4 },
    "rg32uint": { texelSize: 8 },
    "rg32sint": { texelSize: 8 },
    "rg32float": { texelSize: 8 },
    "rgba16uint": { texelSize: 8 },
    "rgba16sint": { texelSize: 8 },
    "rgba16float": { texelSize: 8 },
    "rgba32uint": { texelSize: 16 },
    "rgba32sint": { texelSize: 16 },
    "rgba32float": { texelSize: 16 },
    "stencil8": { texelSize: 1 }, // 1-4
    "depth16unorm": { texelSize: 2 },
    "depth24plus": { texelSize: 4 },
    "depth24plus-stencil8": { texelSize: 4 }, // 4-8
    "depth32float": { texelSize: 4 },
    "depth32float-stencil8": { texelSize: 5 }, // 5-8
    "bc1-rgba-unorm": { texelSize: 8 },
    "bc1-rgba-unorm-srgb": { texelSize: 8 },
    "bc2-rgba-unorm": { texelSize: 16 },
    "bc2-rgba-unorm-srgb": { texelSize: 16 },
    "bc3-rgba-unorm": { texelSize: 16 },
    "bc3-rgba-unorm-srgb": { texelSize: 16 },
    "bc4-r-unorm": { texelSize: 8 },
    "bc4-r-snorm": { texelSize: 8 },
    "bc5-rg-unorm": { texelSize: 16 },
    "bc5-rg-snorm": { texelSize: 16 },
    "bc6h-rgb-ufloat": { texelSize: 16 },
    "bc6h-rgb-float": { texelSize: 16 },
    "bc7-rgba-unorm": { texelSize: 16 },
    "bc7-rgba-unorm-srgb": { texelSize: 16 },
    "etc2-rgb8unorm": { texelSize: 8 },
    "etc2-rgb8unorm-srgb": { texelSize: 8 },
    "etc2-rgb8a1unorm": { texelSize: 8 },
    "etc2-rgb8a1unorm-srgb": { texelSize: 8 },
    "etc2-rgba8unorm": { texelSize: 16 },
    "etc2-rgba8unorm-srgb": { texelSize: 16 },
    "eac-r11unorm": { texelSize: 8 },
    "eac-r11snorm": { texelSize: 8 },
    "eac-rg11unorm": { texelSize: 16 },
    "eac-rg11snorm": { texelSize: 16 },
    "astc-4x4-unorm": { texelSize: 16 },
    "astc-4x4-unorm-srgb": { texelSize: 16 },
    "astc-5x4-unorm": { texelSize: 16 },
    "astc-5x4-unorm-srgb": { texelSize: 16 },
    "astc-5x5-unorm": { texelSize: 16 },
    "astc-5x5-unorm-srgb": { texelSize: 16 },
    "astc-6x5-unorm": { texelSize: 16 },
    "astc-6x5-unorm-srgb": { texelSize: 16 },
    "astc-6x6-unorm": { texelSize: 16 },
    "astc-6x6-unorm-srgb": { texelSize: 16 },
    "astc-8x5-unorm": { texelSize: 16 },
    "astc-8x5-unorm-srgb": { texelSize: 16 },
    "astc-8x6-unorm": { texelSize: 16 },
    "astc-8x6-unorm-srgb": { texelSize: 16 },
    "astc-8x8-unorm": { texelSize: 16 },
    "astc-8x8-unorm-srgb": { texelSize: 16 },
    "astc-10x5-unorm": { texelSize: 16 },
    "astc-10x5-unorm-srgb": { texelSize: 16 },
    "astc-10x6-unorm": { texelSize: 16 },
    "astc-10x6-unorm-srgb": { texelSize: 16 },
    "astc-10x8-unorm": { texelSize: 16 },
    "astc-10x8-unorm-srgb": { texelSize: 16 },
    "astc-10x10-unorm": { texelSize: 16 },
    "astc-10x10-unorm-srgb": { texelSize: 16 },
    "astc-12x10-unorm": { texelSize: 16 },
    "astc-12x10-unorm-srgb": { texelSize: 16 },
    "astc-12x12-unorm": { texelSize: 16 },
    "astc-12x12-unorm-srgb": { texelSize: 16 },
};

export {
    textureTypes,
};

